import { render, staticRenderFns } from "./PermissionGroups.vue?vue&type=template&id=596b243f&"
import script from "./PermissionGroups.vue?vue&type=script&lang=js&"
export * from "./PermissionGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports